import React from 'react'
import TelegramAccountCreatePage from '../../screens/TelegramAccountCreatePage/TelegramAccountCreatePage.component'

const TelegramAccountsCreate: React.FC = () => {
  return <TelegramAccountCreatePage />
}

export default TelegramAccountsCreate